import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `cn` — the canonical shadcn class-name helper.
 *
 * Concatenates a list of conditional class names via `clsx`, then resolves
 * Tailwind class conflicts via `tailwind-merge` (later classes win). Use this
 * everywhere instead of raw string concatenation so component consumers can
 * override defaults predictably.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
